module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-12.v1.jpg";